export default {
  s: '%d секунда',
  smicro: '%d с',
  smid: '%d сек',

  ss: '%d секунд',
  ssfew: '%d секунды',
  ssmicro: '%d с',
  ssmid: '%d сек',

  m: '%d минута',
  mmicro: '%d м',
  mmid: '%d мин',

  mm: '%d минут',
  mmfew: '%d минуты',
  mmmicro: '%d м',
  mmmid: '%d мин',

  h: '%d час',
  hmicro: '%d ч',
  hmid: '%d час',

  hh: '%d часов',
  hhfew: '%d часа',
  hhmicro: '%d ч',
  hhmid: '%d часов',
  hhmidfew: '%d часа',

  d: '%d день',
  dmicro: '%d д',
  dmid: '%d день',

  dd: '%d дней',
  ddfew: '%d дня',
  ddmicro: '%d д',
  ddmid: '%d дней',
  ddmidfew: '%d дня',
};
